'use client';

import { c as _c } from "react/compiler-runtime";
import ClockIcon from '@eversports/design-tokens/assets/icons/regular/clock.svg?icon';
import { cn } from '@eversports/klimt-design-components/tailwind/utils';
import Button from '@eversports/klimt-primitives/Button';
import { RadioGroup, RadioGroupItem } from '@eversports/klimt-primitives/RadioGroup';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Sheet, SheetTrigger } from '../../../../../../../../../components/Sheet';
import FilterSheetContent from '../FilterSheetContent';
import formatTimeFilter from './helpers/format-time-filter';
import { START_TIME_OPTIONS } from './TimeFilter.constants';
interface Props {
  selectedTime: string | null;
  updateFilter: (value: string) => void;
  resetFilter: () => void;
}
const TimeFilterSheet = t0 => {
  const $ = _c(34);
  const {
    selectedTime,
    updateFilter,
    resetFilter
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslations("discover-sport-city");
  let t1;
  if ($[0] !== isOpen) {
    t1 = () => setIsOpen(!isOpen);
    $[0] = isOpen;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const toggleCalendar = t1;
  let t2;
  if ($[2] !== toggleCalendar || $[3] !== updateFilter) {
    t2 = timeSelection => {
      updateFilter(timeSelection);
      toggleCalendar();
    };
    $[2] = toggleCalendar;
    $[3] = updateFilter;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleSelect = t2;
  let t3;
  if ($[5] !== resetFilter || $[6] !== toggleCalendar) {
    t3 = () => {
      resetFilter();
      toggleCalendar();
    };
    $[5] = resetFilter;
    $[6] = toggleCalendar;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleReset = t3;
  const t4 = selectedTime ? "tertiary-selected" : "tertiary";
  const t5 = selectedTime ? "text-text-brand-primary" : "text-text-secondary";
  let t6;
  if ($[8] !== t5) {
    t6 = cn("size-2", t5);
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <ClockIcon className={t6} aria-hidden={true} />;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== selectedTime || $[13] !== t) {
    t8 = selectedTime ? formatTimeFilter(selectedTime) : t("time");
    $[12] = selectedTime;
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t7 || $[17] !== t8) {
    t9 = <SheetTrigger asChild={true} className="order-3 flex flex-1 items-center gap-1 sm:hidden"><Button size="sm" variant={t4}>{t7}{t8}</Button></SheetTrigger>;
    $[15] = t4;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t("starting-time");
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = selectedTime ?? undefined;
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = START_TIME_OPTIONS.map(_temp);
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== handleSelect || $[23] !== t11) {
    t13 = <RadioGroup value={t11} onValueChange={handleSelect}>{t12}</RadioGroup>;
    $[22] = handleSelect;
    $[23] = t11;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== handleReset || $[26] !== t10 || $[27] !== t13) {
    t14 = <FilterSheetContent title={t10} reset={handleReset}>{t13}</FilterSheetContent>;
    $[25] = handleReset;
    $[26] = t10;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== isOpen || $[30] !== t14 || $[31] !== t9 || $[32] !== toggleCalendar) {
    t15 = <Sheet open={isOpen} onOpenChange={toggleCalendar}>{t9}{t14}</Sheet>;
    $[29] = isOpen;
    $[30] = t14;
    $[31] = t9;
    $[32] = toggleCalendar;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};
export default TimeFilterSheet;
function _temp(option) {
  const optionStr = option.toString();
  return <div key={option} className="flex cursor-pointer items-center gap-2 py-1 hover:bg-surface-primary hover:text-text-hover"><RadioGroupItem id={optionStr} value={optionStr} /><label htmlFor={optionStr} className="w-full">{formatTimeFilter(optionStr)}</label></div>;
}